(() => {
  const boot = {
    loaded: true,
    loadedAt: Date.now(),
    src: document.currentScript?.src || null,
    configured: false,
    cacheToken: null,
    manifestUrl: null,
    transformUrl: null,
    error: null,
  };
  window.__HIOOL_PCA192_CACHE_CONFIG_BOOT__ = boot;

  const engine = window.HIOOLVisualSearchPCA192;
  if (!engine?.configure) {
    boot.error = 'HIOOLVisualSearchPCA192.configure is unavailable.';
    console.error('[HIOOL visual] PCA192 cache config failed:', boot.error);
    return;
  }

  const pcaScript = [...document.scripts].find((script) =>
    /hiool-visual-pca192\\.js(?:\\?|$)/.test(script.src || '')
  );
  const baseUrl = pcaScript?.src || document.currentScript?.src || '';
  if (!baseUrl) {
    boot.error = 'PCA192 script URL could not be resolved.';
    console.error('[HIOOL visual] PCA192 cache config failed:', boot.error);
    return;
  }

  const cacheToken = String(Date.now());
  boot.cacheToken = cacheToken;

  function siblingAssetUrl(filename) {
    const url = new URL(filename, baseUrl);
    url.search = '';
    url.searchParams.set('v', cacheToken);
    return url.href;
  }

  function chunkAssetUrl(filename) {
    const normalized = /^hiool-pca192-/.test(filename)
      ? filename
      : `hiool-pca192-${filename}`;
    return siblingAssetUrl(normalized);
  }

  const manifestUrl = siblingAssetUrl('hiool-pca192-manifest.json');
  const transformUrl = siblingAssetUrl('hiool-pca192-transform.json');

  engine.configure({
    manifestUrl,
    transformUrl,
    chunkUrl: chunkAssetUrl,
  });

  boot.configured = true;
  boot.manifestUrl = manifestUrl;
  boot.transformUrl = transformUrl;
})();

